<template>
  <div v-if="isWhiteGloveUser && site?.associatedDomainLevelCampaign" class="pl20 pr20">

    <div class="mt10 mb-5 navigate-bread-part">
      <div class="breadcrumbs-area">
        <a class="back-to-home inline-flex align-center" @click="() => {
          $router.push(`/sites/${ site.id }/tools`)
        }">
          <span class="bread-crumb-size mainColor--text font-weight-bold">{{ site.name }}</span>
        </a>
        <a class="back-to-home inline-flex align-center" @click="() => {
          $router.push(
            `/sites/${site.id}/quick-content-orders`,
          )
        }">
          <i class="material-icons arrow-right-size">chevron_right</i>
          <span class="bread-crumb-size mainColor--text font-weight-bold">My Content</span>
        </a>
      </div>
    </div>

    <div class="pagerun-tabs">
      <ul>
        <li 
          class="is-active"
          style="position: relative;"
        >
          <a @click="() => {
            $router.push(
              `/sites/${site.id}/quick-content-orders`,
            )
          }">
            <span>My Content</span>
          </a>
        </li>
        <li class="flex-grow-1"></li>
      </ul>
    </div>

    <list-view v-if="!this.$route.query.id" :campaignId="site.associatedDomainLevelCampaign"/>
    <single-view v-else :campaignId="site.associatedDomainLevelCampaign"/>
  </div>
</template>

<script>
import { getPureServicePkgName } from '@/utils'
import {
  whiteGlovePlans
} from "@/components/plans_constants";

import ListView from './ListView.vue';
import SingleView from './SingleView.vue';

export default {
  components: {
    ListView,
    SingleView,
  },
  watch: {
    'siteId': {
      handler: function (newVal, oldVal) {
        this.loadSite()
      },
      immediate: true
    }
  },
  computed: {
    siteId() {
      return parseInt(this.$route.params.siteId)
    },
    site() {
      return this.$store.getters.siteById(this.siteId)
    },
    user () {
      if (this.$store.state.user) {
        return this.$store.state.user
      }
      return null
    },
    selectedSubAccountRelation () {
      return this.$store.state.selectedSubAccountRelation
    },
    isWhiteGloveUser () {
      if (!this.user) return false;

      const accountType = this.$store.state.selectedSubAccountRelation
        ?this.$store.state.selectedSubAccountRelation.ownerAccountType
        :this.user.accountType

      if (whiteGlovePlans.includes(getPureServicePkgName(accountType))) {
        return true;
      }
      return false;
    },
  },
  methods: {
    loadSite () {
      if (this.siteId) {
        this.$store.commit('showLoading')
        return this.$store.dispatch('loadSite', this.siteId)
          .then((response) => {
            if (response.data && response.data.status === 'SUCCESS') {
              if (response.data.site) {
                this.$store.commit('setSite', response.data.site)
              }
            }
          })
          .finally(() => {
            this.$store.commit('hideLoading')
          })
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
